(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function updateReplacementProductImages() {
      const sessionData = JSON.parse(sessionStorage.getItem('cartImageData'));

      // 2. Select all cart item rows
      const cartItems = document.querySelectorAll('tr.cart-item');

      // 3. Loop through each cart item
      cartItems.forEach((item) => {
        const mediaCell = item.querySelector('.cart-item__media');
        // Ensure the item has a variant and isn't an add-on without an image
        if (!mediaCell || !mediaCell.dataset.variant) {
          return; // Skip this item if it has no variant data
        }

        const variantId = mediaCell.dataset.variant;
        const imageElement = item.querySelector('.cart-item__image');

        // Skip if there's no image element to update
        if (!imageElement) {
          return;
        }

        // Find all the product options (like color, filter, etc.)
        const productOptions = item.querySelectorAll('.product-option');

        // 4. Loop through options to find the correct one and build the session key
        productOptions.forEach((option) => {
          const dt = option.querySelector('dt');
          const dd = option.querySelector('dd');

          if (dt && dd) {
            // Clean the text to match the session key format
            const filter = dt.textContent.replace(':', '').trim();
            const color = dd.textContent.trim();

            // 5. Construct the key and check session data
            const key = `${variantId}_${color}_${filter}`;

            if (sessionData && sessionData[key]) {
              const newImageUrl = sessionData[key].imageUrl;

              // 6. Update the image source
              // Adjust width to 300 as seen in the original src
              const sizedImageUrl = newImageUrl.replace(/&width=\d+/, '&width=300');
              imageElement.src = sizedImageUrl;

              console.log(`Updated image for variant ${variantId} with color ${color}.`);
            }
          }
        });
      });
    }
    setTimeout(updateReplacementProductImages, 1000);

    // Only show spinner if cart is not empty
    if (!document.querySelector('.cart-page').classList.contains('is-empty')) {
      // Show loading spinner
      const spinner = document.createElement('div');
      spinner.classList.add('loading-spinner');
      spinner.innerHTML = `
        <style>
          .loading-spinner {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(255,255,255,0.8);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
          }
          .loading-spinner:after {
            content: '';
            width: 50px;
            height: 50px;
            border: 5px solid #f3f3f3;
            border-top: 5px solidrgb(25, 27, 27);
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        </style>
      `;
      document.body.appendChild(spinner);

      // Remove spinner after 3 seconds
      setTimeout(() => {
        spinner.remove();
      }, 2000);
    }

    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }

    function formatHeadings(selector) {
      const headings = document.querySelectorAll(selector);

      headings.forEach((heading) => {
        const fullText = heading.textContent;
        const match = fullText.match(/(Replacement Lens(?:es)?)/);

        if (match) {
          const matchText = match[0];
          const splitIndex = fullText.indexOf(matchText);
          const beforeText = fullText.substring(0, splitIndex).trim();
          const afterText = fullText.substring(splitIndex + matchText.length);

          heading.innerHTML = `
          <span>${beforeText}</span>
          <span class="subheading-card">${matchText}${afterText}</span>
        `;
          heading.classList.add('custom-heading-card');
        }
      });
    }

    setTimeout(() => {
      formatHeadings('.cart-item__name');
    }, 1050);
  });

  } catch(e) { console.error(e); }
})();
})();
